import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { InputErrorComponent } from '../components/input-error/input-error.component';
import { Subject, takeUntil } from 'rxjs';

@Directive({
	selector: '[formInvalidType], [cdxInvalidType]',
	standalone: true,
})
export class InvalidTypeDirective implements OnInit, OnDestroy {
	@Input('cdxInvalidType') type: string;
	@Input() ignoreWhileUntouched: boolean;

	injectedView: any;
	private destroyed$: Subject<boolean> = new Subject();

	constructor(private inputError: InputErrorComponent, private el: ElementRef) {}

	ngOnInit(): void {
		this.el.nativeElement.classList.add('form-errorText--hide');
		this.inputError.controlStatus$.pipe(takeUntil(this.destroyed$)).subscribe(() => {
			// allows you to reset the form without validation errors appearing since the control status will emit
			// TODO: improve functionality via CO-9268
			if (this.ignoreWhileUntouched && this.inputError.formControl?.untouched) {
				return;
			}

			this.setVisible();
		});
	}

	ngOnDestroy(): void {
		this.destroyed$.next(true);
		this.destroyed$.complete();
	}

	private setVisible(): void {
		const hasError = this.inputError.getErrorType(this.type);
		// below code has been written to make it work in IE11
		// toggle or replace wouldnt work in all browsers
		if (hasError) {
			this.el.nativeElement.classList.remove('form-errorText--hide');
			this.el.nativeElement.classList.add('form-errorText');
		} else {
			this.el.nativeElement.classList.add('form-errorText--hide');
			this.el.nativeElement.classList.remove('form-errorText');
		}
	}
}
